import { ENTORNO } from "../utils/constantes";
import { getToken } from "../utils/variablesLocales";

export class apiMobbex {
  baseApi = ENTORNO.BASE_API;

  //   async crearCliente(reference, email, name, identification) {
  //     try {
  //       const url = `${this.baseApi}/${ENTORNO.API_ROUTES.MOBBEXcrearCliente}`;

  //       const parametros = {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${getToken()}`,
  //         },
  //         body: JSON.stringify({
  //           reference: reference, //id de usuario
  //           email: email,
  //           name: name,
  //           identification: identification, //dni/pas de pasajero
  //         }),
  //       };

  //       const respuesta = await fetch(url, parametros);
  //       const respuestaJson = await respuesta.json();

  //       if (respuesta.status !== 200) throw respuestaJson;

  //       return respuestaJson;
  //     } catch (error) {
  //       throw error;
  //     }
  //   }

  //   async crearTarjeta(number, month, year, identification, name) {
  //     try {
  //       const url = `${this.baseApi}/${ENTORNO.API_ROUTES.MOBBEXcrearTarjeta}`;

  //       const parametros = {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${getToken()}`,
  //         },
  //         body: JSON.stringify({
  //           number: number,
  //           month: month,
  //           year: year,
  //           identification: identification,
  //           name: name,
  //         }),
  //       };

  //       const respuesta = await fetch(url, parametros);
  //       const respuestaJson = await respuesta.json();

  //       if (respuesta.status !== 200) throw respuestaJson;

  //       return respuestaJson;
  //     } catch (error) {
  //       throw error;
  //     }
  //   }

  //   async crearRelacion(customerUID, token) {
  //     try {
  //       const url = `${this.baseApi}/${ENTORNO.API_ROUTES.MOBBEXcrearRelacion}`;

  //       const parametros = {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${getToken()}`,
  //         },
  //         body: JSON.stringify({
  //           customerUID: customerUID,
  //           token: token,
  //         }),
  //       };

  //       const respuesta = await fetch(url, parametros);
  //       const respuestaJson = await respuesta.json();

  //       if (respuesta.status !== 200) throw respuestaJson;

  //       return respuestaJson;
  //     } catch (error) {
  //       throw error;
  //     }
  //   }

  //   async realizarPago(customerUID, total, IdViaje, securityCode) {
  //     try {
  //       const url = `${this.baseApi}/${ENTORNO.API_ROUTES.MOBBEXrealizarPago}`;

  //       const parametros = {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${getToken()}`,
  //         },
  //         body: JSON.stringify({
  //           customerUID: customerUID,
  //           total: total,
  //           IdViaje: IdViaje,
  //           securityCode: securityCode,
  //         }),
  //       };

  //       const respuesta = await fetch(url, parametros);
  //       const respuestaJson = await respuesta.json();
  //       return respuestaJson;
  //     } catch (error) {
  //       throw error;
  //     }
  //   }
  // }

  async checkout(ViajeId, Idioma) {
    try {
      const url = `${this.baseApi}/${ENTORNO.API_ROUTES.MOBBEXcheckout}`;

      const parametros = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify({
          ViajeId: ViajeId,
          Idioma: Idioma,
        }),
      };

      const respuesta = await fetch(url, parametros);
      const respuestaJson = await respuesta.json();

      return respuestaJson;
    } catch (error) {
      throw error;
    }
  }
}
